export default {
      id: "ic-nav-access-usage",
      viewBox: "0 0 30 31",
      url: "../dist/images/" + "sprite.svg#ic-nav-access-usage",
      toString: function () {
        return this.url;
      }
    }